import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./Dashboard.css";
import Wallet from "../Wallet/Wallet";
import DashNavigation from "../DashNavigation/DashNavigation";
import Deposit from "../Deposit/Deposit";
import Settings from "../Settings/Settings";
import Transaction from "../Transaction/Transaction";
import Withdraw from "../Withdraw/Withdraw";
import UserPrivateRoute from "../../../utils/UserPrivateRoute";
import Card from "../Card";
import InvestmentHub from "../InvestmentHub/InvestmentHub";

const Dashboard = () => {
  const { pathname } = useLocation();

  return (
    <section className="dashboard">
      <DashNavigation pathname={pathname} />
      <div className="path">
        <Routes>
          <Route element={<UserPrivateRoute />}>
            <Route element={<Wallet />} path="/wallet" />
            <Route element={<InvestmentHub />} path="/investments" />
            <Route element={<InvestmentHub />} path="/markets" />
            <Route element={<Deposit />} path="/deposit" />
            <Route path="/account" element={<Navigate to="/wallet" replace />} />
            <Route element={<Settings />} path="/settings" />
            <Route element={<Transaction />} path="/transactions" />
            <Route element={<Card />} path="/get-card" />
            <Route element={<Withdraw />} path="/withdrawal" />
          </Route>
        </Routes>
      </div>
    </section>
  );
};

export default Dashboard;
